// LANATURA – dodavanje ponude i zaštite paketa iz korpe, bez osvežavanja stranice.
import { CartLinesUpdateEvent } from '@shopify/events';

function cartSectionIds() {
  return Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
}

async function mutateCart(sourceEl, url, payload, eventInit) {
  const deferred = CartLinesUpdateEvent.createPromise();

  sourceEl.dispatchEvent(
    new CartLinesUpdateEvent({
      ...eventInit,
      context: 'cart',
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        ...payload,
        sections: cartSectionIds().join(','),
        sections_url: window.location.pathname,
      }),
    });
    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Cart update failed');
    }

    const cart = await fetch(`${Theme.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then((r) => r.json());

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        sections: data.sections,
        source: 'ln-cart-extras',
        didError: false,
      },
    });
  } catch (error) {
    console.error('[ln-cart-extras]', error);
    deferred.reject(error);
    window.location.reload();
  }
}

document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-ln-cart-add]') : null;
  if (!button || button.disabled) return;
  event.preventDefault();

  button.disabled = true;
  const variantId = button.getAttribute('data-ln-cart-add');

  mutateCart(
    button,
    Theme.routes.cart_add_url,
    { items: [{ id: Number(variantId), quantity: 1 }] },
    { action: 'add', lines: [{ merchandiseId: String(variantId), quantity: 1 }] }
  );
});

document.addEventListener('change', (event) => {
  const box = event.target instanceof Element ? event.target.closest('[data-ln-protect]') : null;
  if (!box) return;

  box.disabled = true;
  const variantId = box.getAttribute('data-variant-id');
  const lineKey = box.getAttribute('data-line-key');

  if (box.checked) {
    mutateCart(
      box,
      Theme.routes.cart_add_url,
      { items: [{ id: Number(variantId), quantity: 1 }] },
      { action: 'add', lines: [{ merchandiseId: String(variantId), quantity: 1 }] }
    );
  } else if (lineKey) {
    mutateCart(
      box,
      `${Theme.routes.cart_change_url}.js`,
      { id: lineKey, quantity: 0 },
      { action: 'remove', lines: [{ id: lineKey, quantity: 0 }] }
    );
  } else {
    window.location.reload();
  }
});
